import { c as _c } from "react/compiler-runtime";
import { useProvider } from '@newfront-insurance/react-provision';
import type { PropsWithChildren, JSX } from 'react';
import { employeeErrorMessages } from './lib/messages';
import { LayoutConfigProvider } from '../../config';
import { ErrorBoundaryWithMessages } from '../error-boundary/error-boundary';

/**
 * This error boundary should only be used in internal apps. It will define the copy for the
 * error messages and assume the user is an employee.
 */
export function InternalAppErrorBoundary(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  const {
    onError
  } = useProvider(LayoutConfigProvider);
  let t1;
  if ($[0] !== children || $[1] !== onError) {
    t1 = <ErrorBoundaryWithMessages onError={onError} messages={employeeErrorMessages}>{children}</ErrorBoundaryWithMessages>;
    $[0] = children;
    $[1] = onError;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}